import React from 'react';
import PropTypes from 'prop-types';

const CheckList = ({children}) => {
    return (
        <div className="checklist">
            {children}
        </div>
    );
};

CheckList.propTypes = {
    children: PropTypes.node.isRequired,
};

export default CheckList;
